import { useFindingDefinition } from "@repo/data-store";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { CatalogDefinition, FindingDefinitionRevise } from "@/features/catalog";
import { findingDefinitionUrlFromRouteId } from "@/features/catalog/lib/finding-definition-route";

export const Route = createFileRoute("/catalog/findings/$findingId_/edit")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canRead("Questionnaire")) throw redirect({ to: "/catalog/exams" });
  },
  component: EditFindingDefinitionComponent,
});

function EditFindingDefinitionComponent() {
  const { findingId } = Route.useParams();
  const { permissions } = Route.useRouteContext();
  const navigate = useNavigate();
  const finding = useFindingDefinition(findingDefinitionUrlFromRouteId(findingId));
  const navigateBack = useCallback(
    () => navigate({ to: "/catalog/findings/$findingId", params: { findingId } }),
    [findingId, navigate],
  );

  if (!finding) {
    return <CatalogDefinition.NotFound label="Finding" backTo="/catalog/exams" backLabel="Back to catalog" />;
  }

  return (
    <FindingDefinitionRevise
      key={findingId}
      finding={finding}
      canEdit={permissions.canWrite("ObservationDefinition")}
      onDone={navigateBack}
      onCancel={navigateBack}
    />
  );
}
